import GreenhouseGasEmissions from './GreenhouseGasEmissions';
import ESGSummary from './ESGSummary';

export default { GreenhouseGasEmissions, ESGSummary };
